import type { ITodoListTrackerIconProps } from './helpers';

export const TodoListTrackerIcon = ({ status, ...rest }: ITodoListTrackerIconProps) => {
	if (status === 'pending')
		return (
			<svg
				width='32'
				height='32'
				viewBox='0 0 32 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.5'
					y='0.5'
					width='31'
					height='31'
					rx='15.5'
					fill='white'
				/>
				<rect
					x='0.5'
					y='0.5'
					width='31'
					height='31'
					rx='15.5'
					stroke='#05A2BF'
				/>
				<circle
					cx='16'
					cy='16'
					r='3.5'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (status === 'get-started')
		return (
			<svg
				width='32'
				height='32'
				viewBox='0 0 32 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.5'
					y='0.5'
					width='31'
					height='31'
					rx='15.5'
					fill='white'
				/>
				<rect
					x='0.5'
					y='0.5'
					width='31'
					height='31'
					rx='15.5'
					stroke='#ECEEEE'
				/>
			</svg>
		);

	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 35 35'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				width='32'
				height='32'
				rx='16'
				fill='#05A2BF'
			/>
			<path
				d='M14.3434 20.1765C14.1101 20.1765 13.8884 20.0832 13.7251 19.9199L10.4234 16.6182C10.0851 16.2799 10.0851 15.7199 10.4234 15.3815C10.7618 15.0432 11.3218 15.0432 11.6601 15.3815L14.3434 18.0649L20.3401 12.0682C20.6784 11.7299 21.2384 11.7299 21.5768 12.0682C21.9151 12.4065 21.9151 12.9665 21.5768 13.3049L14.9618 19.9199C14.7984 20.0832 14.5768 20.1765 14.3434 20.1765Z'
				fill='white'
			/>
		</svg>
	);
};
